import { he } from "../../../../date-fns/locale/he.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    he
  }
};